/**
 * The numbers at the top of a record: a tile per number, its name, its value
 * and a line under it (`tiles`: { key, label, value, detail }). A tile with an
 * entry in `actions` ({ [key]: onClick }) is a button: the record opens the
 * tab its number comes from.
 */
const TILE_CLASS = 'rounded-xl border border-gray-100 p-4 text-left';

const KpiTiles = ({ tiles, actions = {} }) => (
  <div className="grid grid-cols-1 gap-3 tab:grid-cols-3">
    {tiles.map((tile) => {
      const body = (
        <>
          <p className="text-sm font-medium text-gray-900">{tile.label}</p>
          <p className="mt-1 text-2xl font-medium text-gray-900">{tile.value}</p>
          <p className="mt-1 text-xs text-gray-600">{tile.detail}</p>
        </>
      );
      const open = actions[tile.key];
      return open ? (
        <button
          key={tile.label}
          type="button"
          onClick={open}
          className={`${TILE_CLASS} transition-colors hover:border-gray-200 hover:bg-gray-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gray-300`}
        >
          {body}
        </button>
      ) : (
        <div key={tile.label} className={TILE_CLASS}>
          {body}
        </div>
      );
    })}
  </div>
);

export default KpiTiles;
